import { useContext, useLayoutEffect, useRef, useState } from "react";
import { ForMnSteps, BurgerButtonBig, ButtonRound, DropdownInfo, HeaderBig, LearnMore, SignupBox, TabSwitch, LinkSmart } from "../common/Common";
import './HowItWorks.css';
import { LocaleContext, ScrollContext } from "../common/App";
import { Link } from "react-router-dom";
import { Footer, ForFamiliesSteps, PricingText } from "./WebsiteCommon";
import { useIndexUpdate, useNavigateSmart } from "../common/hooks";
import { UserType } from "../common/enums.mjs";
import { WebsiteContext } from "./WebsiteApp";

export function HowItWorks(props) {
    const locale = useContext(LocaleContext);
    const website = useContext(WebsiteContext);

    const navigate = useNavigateSmart();

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div className="how_it_works head_img">
            <img className="img_width" src="/customer/images/how_it_works_1.jpg" alt={locale.msgs.HOW_IT_WORKS_IMG_1_ALT_TEXT}></img>
            <div className="text_box">
                <h1 className="text_big_big head_after_img">{locale.msgs.HOW_IT_WORKS}</h1>
                <div className="text">
                    <span dangerouslySetInnerHTML={{__html: locale.msgs.HOW_IT_WORKS_2_DESCR_1}} />
                    <LinkSmart className="link_2" to="/faq/?question=39" /*target="_blank"*/>{locale.msgs.LEARN_MORE_2}</LinkSmart>
                    <div dangerouslySetInnerHTML={{__html: locale.msgs.HOW_IT_WORKS_2_DESCR_2}} />
                </div>
            </div>

            <div className="margin_top_low">
                <TabSwitch tabNames={[locale.msgs.FOR_FAMILIES, locale.msgs.FOR_M_N_SHORT]}
                            tabElements={[
                                <div className="steps_tab_box">
                                    <ForFamiliesSteps/>

                                    <div className="text_big_big margin_top_high">{locale.msgs.AMOUNT_OF_FEES}</div>
                                    <PricingText />

                                    <div className="margin_top_high">
                                        <SignupBox header={locale.msgs.FIND_MANNY_OR_NANNY} descr={locale.msgs.FIND_MANNY_OR_NANNY_DESCR_HOW_IT_WORKS}
                                                onClick={() => {
                                                    website.setRegisterInfo({...website.registerInfo, "userType": UserType.FAMILY});
                                                    navigate("/register/");
                                                }} />
                                    </div>
                                </div>
                                , 
                                <div className="steps_tab_box">
                                    <ForMnSteps/>

                                    <div className="margin_top_high">
                                        <SignupBox header={locale.msgs.FIND_JOB} descr={locale.msgs.FIND_JOB_DESCR_HOW_IT_WORKS}
                                                onClick={() => {
                                                    website.setRegisterInfo({...website.registerInfo, "userType": UserType.NANNY});
                                                    navigate("/register/");
                                                }} />
                                    </div>
                                </div>
                            ]}
                            sameTabWidth={true}
                />
            </div>

            <div className="text_box margin_bottom_high"></div>

            <Footer />
        </div>
    );
}
